<template>
    <Controller>
        <page-header title="Negocie Já - Formas de Pagamento"/>
    </Controller>
</template>

<script>
import Controller from '@/components/template/Controller.vue';


    export default{
        components: { Controller },
    }
</script>